import { useCallback, useEffect, useMemo, useRef, useState } from "react";

const useListKeyboardCommands = () => {
  // States
  const [currentIndex, setCurrentIndex] = useState(-1);

  // Refs
  const internalData = useRef({
    listSize: -1,
    currentIndex: -1,
    enabled: true,
    onEnterHandler: () => {}
  });
  const keyboardKeyDownHandlerRef = useRef(null);

  // Callbacks
  const setInternalCurrentIndex = useCallback(index => {
    internalData.current.currentIndex = index;
    setCurrentIndex(index);
  }, []);

  // Memos
  const methods = useMemo(
    () => ({
      start() {
        if (!keyboardKeyDownHandlerRef.current) {
          keyboardKeyDownHandlerRef.current = event => {
            if (!internalData.current.enabled) {
              return;
            }

            if (
              event.keyCode === 38 ||
              event.keyCode === 40 ||
              event.keyCode === 13
            ) {
              event.stopPropagation();
              event.preventDefault();
            }
            if (event.keyCode === 38) {
              if (internalData.current.currentIndex !== 0) {
                setInternalCurrentIndex(internalData.current.currentIndex - 1);
              }
            } else if (event.keyCode === 40) {
              if (
                internalData.current.currentIndex <
                internalData.current.listSize - 1
              ) {
                setInternalCurrentIndex(internalData.current.currentIndex + 1);
              } else {
                setInternalCurrentIndex(0);
              }
            } else if (event.keyCode === 13) {
              internalData.current.onEnterHandler(
                event,
                internalData.current.currentIndex
              );
            }
          };
          window.addEventListener("keyup", keyboardKeyDownHandlerRef.current);
          setInternalCurrentIndex(0);
        }
      },
      reset() {
        if (keyboardKeyDownHandlerRef.current) {
          setInternalCurrentIndex(0);
        }
      },
      stop() {
        window.removeEventListener("keyup", keyboardKeyDownHandlerRef.current);
        keyboardKeyDownHandlerRef.current = null;
        setInternalCurrentIndex(-1);
      },
      setListSize(listSize) {
        internalData.current.listSize = listSize;
      },
      setEnterHandler(handler) {
        internalData.current.onEnterHandler = handler;
      },
      disable() {
        internalData.current.enabled = false;
      },
      enable() {
        internalData.current.enabled = true;
      }
    }),
    [setInternalCurrentIndex]
  );

  useEffect(() => {
    return () => {
      if (keyboardKeyDownHandlerRef.current) {
        window.removeEventListener("keyup", keyboardKeyDownHandlerRef.current);
      }
    };
  }, []);

  return { currentIndex, methods, internalData };
};

export default useListKeyboardCommands;
